export interface AvailableFonts {
    SourceSansPro200: string;
    SourceSansPro300: string;
    SourceSansPro400: string;
    SourceSansPro600: string;
    SourceSansPro700: string;
    SourceSansPro900: string;
}

const Fonts: AvailableFonts = {
    SourceSansPro200: "sourceSansPro/files/source-sans-pro-latin-200-normal.ttf",
    SourceSansPro300: "sourceSansPro/files/source-sans-pro-latin-300-normal.ttf",
    SourceSansPro400: "sourceSansPro/files/source-sans-pro-latin-400-normal.ttf",
    SourceSansPro600: "sourceSansPro/files/source-sans-pro-latin-600-normal.ttf",
    SourceSansPro700: "sourceSansPro/files/source-sans-pro-latin-700-normal.ttf",
    SourceSansPro900: "sourceSansPro/files/source-sans-pro-latin-900-normal.ttf",
};

const fontSource = (font: string): string => {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    return require(`../assets/fonts/${font}`);
};

export { Fonts, fontSource };
